import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const telemedicinesApi = baseApi.injectEndpoints({
  tagTypes: ["Telemidicines"],
  endpoints: (builder) => ({
    getTelemedicines: builder.query({
      query: (params) => {
        return {
          url: `/telemeds/listingPatientPortal.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetTelemedicinesQuery } = telemedicinesApi;
